<template>
    <div class="page">
        <div class="search">
            <div class="df">
                <div class="search-box">
                    <div class="search-item">
                        <div class="label">课程ID:</div>
                        <a-input-number id="inputNumber" v-model="params.courseId" :min="1" placeholder="请输入"
                            style="width: 200px;" />
                    </div>
                    <div class="search-item">
                        <div class="label">课程名称:</div>
                        <a-input placeholder="请输入" v-model="params.courseName"></a-input>
                    </div>
                    <div class="search-item">
                        <div class="label">课程提供方:</div>
                        <a-select placeholder="请选择" allowClear v-model="params.institutionId" @change="$forceUpdate()">
                            <a-select-option v-for="(item, index) in institutionList" :key="index" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="search-item">
                        <div class="label">课程周期:</div>
                        <a-select placeholder="请选择" allowClear v-model="params.tagCycle" @change="$forceUpdate()">
                            <a-select-option v-for="item in courseCycleList" :key="item.id" :value="item.id">
                                {{ item.tagName }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="search-item">
                        <div class="label">课程梯度:</div>
                        <a-select placeholder="请选择" allowClear v-model="params.tagGradient" @change="$forceUpdate()">
                            <a-select-option v-for="item in courseGradientList" :key="item.id" :value="item.id">
                                {{ item.tagName }}
                            </a-select-option>
                        </a-select>
                    </div>

                </div>
                <div class="add-btn">
                    <!-- <a-button type="primary" @click="addCourse()">新建课程</a-button> -->
                    <div class="df">
                        <a-button type="primary" style="width: 88px;" @click="search()">查询</a-button>
                        <a-button style="width: 88px;margin-left: 12px;" @click="reset()">重置</a-button>
                        <a class="download" @click="exportCourse()">导出</a>
                    </div>
                </div>
            </div>
            <div class="search-type">
                <a-button class="type-box" :class="item.value === searchType ? 'active' : ''"
                    @click="chooseSearchType(item.value, 1)" v-for="item in typeList" :key="item.value">
                    {{ item.label }}
                </a-button>
            </div>
            <!-- 德智体美劳 -->
            <div class="cate">
                <div class="cate-first search-type">
                    <a-button class="type-box" v-for="item in cateFirstList" :key="item.id"
                        @click="getCateLevelList(1, item.id)" :class="item.id === cateFirstId ? 'active' : ''">{{
                            item.name }}</a-button>
                </div>
                <div class="cate-box" v-if="cateSecondList.length">
                    <a class="cate-text" v-for="item in cateSecondList" :key="item.id"
                        @click="getCateLevelList(2, item.id)" :class="item.id === cateSecondId ? 'active' : ''">{{
                            item.name }}</a>
                </div>
                <div class="cate-box" v-if="cateThirdList.length">
                    <a class="cate-text" v-for="item in cateThirdList" :key="item.id"
                        @click="getCateLevelList(3, item.id)" :class="item.id === cateThirdId ? 'active' : ''">
                        {{ item.name }}</a>
                </div>
            </div>
            <div class="sort df">
                <a class="sort-text" v-for="item in sortList" :key="item.value" @click="chooseSearchType(item.value, 2)"
                    :class="item.value === params.sortType ? 'active1' : ''">
                    {{ item.label }}
                </a>
            </div>
        </div>
        <div class="course" v-if="courseList.length">
            <div class="course-box" v-for="item in courseList" :key="item.id">
                <div class="course-item" @click="openDrawer(item)">
                    <a>
                        <div class="choose" v-if="item.selectStatus == 1">已选</div>
                        <div class="pic">
                            <img v-if="item.coverUrl && item.coverUrl != 'undefined'" :src="item.coverUrl">
                            <img v-else src="../../../public/gateway/course/defaultImg.png">
                        </div>
                        <div class="info">
                            <div class="title">
                                <a-popover>
                                    <template slot="content">
                                        <p>{{ item.courseName }}</p>
                                    </template>
                                    <div class="ellipsis">{{ item.courseName }}</div>
                                </a-popover>
                                <div class="price">¥{{ item.totalPriceText }}</div>
                            </div>
                            <div class="text">
                                ID: {{ item.id }}, {{ item.classHours }}节课, {{ item.classNum ? '已经开设' + item.classNum +
                                    '个' : '未开设' }}班级
                            </div>
                            <div class="status">
                                <template v-if="$store.state.common.tags">
                                    <a-tag style="border-radius: 50%; vertical-align: middle; padding: 3px" :color="item.statusText === '审核通过'
                                        ? '#68CC2E'
                                        : item.statusText === '审核不通过'
                                            ? '#FA5151'
                                            : '#FFA91F'
                                        ">
                                    </a-tag>
                                    {{ item.statusText }}
                                </template>
                                <img v-if="item.isPlatform" style="margin-left: 6px;width: 82px; height: 20px"
                                    src="../../assets/isPlatform.png" />
                            </div>
                            <div class="provide">
                                <div class="logo">
                                    <img
                                        :src="item.providerHeadImg ? item.providerHeadImg : '../../../gateway/course/institution.png'" />
                                    <a-popover>
                                        <template slot="content">
                                            <p>由{{ item.providerNameList[0] }}提供课程服务</p>
                                        </template>
                                        <span class="ellipsis" style="color: #414141">由{{ item.providerNameList[0]
                                        }}提供课程服务</span>
                                    </a-popover>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="pagination">
                <a-pagination v-model="params.currentPage" :defaultPageSize="8" :total="pagination.total"
                    show-quick-jumper @change="onChange" :show-total="total => `总共 ${total} 项`" />
            </div>
        </div>
        <div v-else class="empty">
            <a-empty />
        </div>
        <!-- 课程详情 -->
        <CourseCenterDetail v-if="showDrawer" :showDrawer.sync="showDrawer" :courseItem="courseItem" @refresh="getList"
            @edit="addCourse" :courseNeedCheck="courseNeedCheck">
        </CourseCenterDetail>
        <!-- 新建/修改 -->
        <CourseCenterForm v-show="formDrawer" :showDrawer.sync="formDrawer" ref="courseForm" @refresh="getList">
        </CourseCenterForm>
    </div>
</template>

<script>
import CourseCenterDetail from './components/CourseCenterDetail.vue'
import CourseCenterForm from './components/CourseCenterForm.vue'
import bureau from '../../api/bureau'
import course from '../../api/course'
import Vue from 'vue'
const typeList = [
    { label: '全部', value: -1 },
    { label: '已加入选课', value: 1 },
    { label: '未加入选课', value: 0 }
]
const sortList = [
    { label: '综合排序', value: 1 },
    { label: '最新时间', value: 2 },
    { label: '最多报名', value: 3 },
]

export default {
    data() {
        return {
            typeList,
            sortList,
            params: {
                currentPage: 1,
                selectStatus: null,
                sortType: 1,
                pageSize: 8,
            },
            searchType: -1,
            pagination: {
                currentPage: 1,
                pageSize: 8,
                total: 0
            },
            courseList: [],
            institutionList: [],
            courseCateLevel: Vue.ls.get('courseCateLevel'),
            courseCycleList: [],
            courseGradientList: [],
            cateFirstId: null,
            cateSecondId: null,
            cateThirdId: null,
            cateFirstList: [],
            cateSecondList: [],
            cateThirdList: [],
            showDrawer: false, // 详情
            formDrawer: false, // 新建
            courseItem: null,
            courseNeedCheck: false, // 课程是否需要审核
        }
    },
    components: {
        CourseCenterDetail,
        CourseCenterForm
    },
    created() {
        this.courseCycleList = Vue.ls.get('courseCycle').filter(item => item.parentId !== 0)
        this.courseGradientList = Vue.ls.get('courseGradient').filter(item => item.parentId !== 0)
        this.getCourseCheckSetting()
        this.getCateLevelList(0)
    },
    mounted() {
    },
    methods: {
        getCateLevelList(level, cateId) {
            if (level == 0) {
                this.cateFirstList = this.courseCateLevel.map((item, index) => {
                    return {
                        name: item.name,
                        id: item.id
                    }
                })
                this.cateFirstList.unshift({ name: '全部', id: null })
                this.cateFirstId = null
                this.cateSecondId = null
                this.cateThirdId = null
            } else if (level == 1) {
                this.cateFirstId = cateId
                if (cateId && this.courseCateLevel.find(item => item.id == cateId).children.length) {
                    this.cateSecondList = this.courseCateLevel.find(item => item.id == cateId).children.map(item => {
                        return {
                            name: item.name,
                            id: item.id,
                            children: item.children ? item.children : []
                        }
                    })
                    this.cateSecondList.unshift({ name: '全部', id: null })
                } else {
                    this.cateSecondList = []
                }
                this.cateSecondId = null
                this.cateThirdId = null
                this.cateThirdList = []
            } else if (level == 2) {
                this.cateSecondId = cateId
                if (cateId && this.cateSecondList.find(item => item.id == cateId).children.length) {
                    this.cateThirdList = this.cateSecondList.find(item => item.id == cateId).children.map(item => {
                        return {
                            name: item.name,
                            id: item.id
                        }
                    })
                    this.cateThirdList.unshift({ name: '全部', id: null })
                } else {
                    this.cateThirdList = []
                }
                this.cateThirdId = null
            } else {
                this.cateThirdId = cateId ? cateId : null
            }
            this.$forceUpdate()
            this.getList()
        },
        reset() {
            this.params.courseId = null
            this.params.courseName = null
            this.params.institutionId = undefined
            this.params.tagCycle = undefined
            this.params.tagGradient = undefined
            this.params.status = undefined
            this.$forceUpdate()
        },
        search() {
            this.reSetPage()
            this.getList()
        },
        reSetPage() {
            this.params.currentPage = 1
            this.pagination.currentPage = 1
        },
        exportCourse() {
            let params = {
                ...this.params
            }
            if (this.cateFirstId) params.cateFirstId = this.cateFirstId
            if (this.cateSecondId) params.cateSecondId = this.cateSecondId
            if (this.cateThirdId) params.cateThirdId = this.cateThirdId
            console.log('exportCourse', params)
            course.exportCourseCenter(params).then(res => {
                const url = res.msg
                let dom = document.createElement('a')
                dom.style.display = 'none'
                dom.href = url
                dom.setAttribute('download', '课程列表.xlsx')
                document.body.appendChild(dom)
                dom.click()
            }).catch(err => {
                this.$message.error(err.message)
            })
        },
        chooseSearchType(type, num) {
            this.reSetPage()
            if (num == 1) {
                this.searchType = type
                if (type == -1) {
                    delete this.params.selectStatus
                } else {
                    this.params.selectStatus = type
                }
            } else {
                this.params.sortType = type
            }
            this.getList()
        },
        openDrawer(item) {
            this.courseItem = item
            this.showDrawer = true
        },
        addCourse(item) {
            this.formDrawer = true
            this.$nextTick(() => {
                if (item) {
                    this.$refs.courseForm.init('update', item)
                } else {
                    this.$refs.courseForm.init('add')
                }
            })
        },
        getList() {
            this.params.cateFirstId = this.cateFirstId
            this.params.cateSecondId = this.cateSecondId
            this.params.cateThirdId = this.cateThirdId
            course.getCourseCenterList(this.params).then(res => {
                this.courseList = res.data.list
                this.courseList.forEach(item => {
                    item.totalPriceText = (item.totalPrice / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                })
                this.pagination = res.data.pagination
                if (!this.institutionList.length) {
                    for (let k in res.institutionMap) {
                        this.institutionList.push({ id: k, name: res.institutionMap[k] })
                    }
                }
            })
        },
        onChange(e) {
            this.params.currentPage = e
            this.pagination.currentPage = e
            this.getList()
        },

        // 获取学校设置
        getCourseCheckSetting() {
            bureau.getBureauSetting("school_course_status").then(res => {
                if (res.code == 0 && res.data && res.data.length == 1) {
                    this.courseNeedCheck = (res.data[0].settingValue == "1");
                }
            });
        },
    }
}
</script>

<style scoped lang="less">
.page {
    font-size: 14px;
    padding: 20px;
    font-family: PingFangSC, PingFang SC;
    background-color: #f0f2f5;
}

.df {
    display: flex;
}

::v-deep .ant-input,
::v-deep .ant-select {
    width: 200px;
}

.search {
    background-color: #fff;
    width: 100%;
    padding: 24px;
    justify-content: space-between;
    border-bottom: 1px solid #E0E2E4;

    .add-btn {
        text-align: right;
        margin-left: 20px;
    }


    .sort-text {
        color: #747778;
        margin-right: 20px;
    }

    .sort-text:hover {
        opacity: 0.8;
    }

    .active1 {
        color: #3198FF;
    }
}

.search-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 8px;

    .search-item {
        display: flex;
        width: 33%;
        margin-bottom: 8px;

        .label {
            margin-right: 8px;
            line-height: 32px;
            min-width: 74px;
            color: #171A1D;
        }
    }
}

.search-type {
    margin-bottom: 8px;
    display: flex;
    color: #161A1D;

    .type-box {
        margin-right: 10px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 1px solid #E3E3E3;
        line-height: 14px;
    }

    .active {
        background: #3198FF;
        color: #fff;
    }
}

.course {
    min-width: 1274px;
    display: flex;
    background-color: #fff;
    padding: 23px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .course-box {
        width: 25%;
        min-width: 292px;
        max-width: 420px;
        margin-bottom: 20px;

        .course-item {
            max-width: 95%;
            min-width: 292px;
            border-radius: 10px;
            border: 1px solid #E3E3E3;
            position: relative;

            .choose {
                position: absolute;
                top: 0;
                left: 0;
                padding: 3px 13px;
                font-size: 18px;
                background-color: #3198FF;
                border-radius: 9px 0 10px 0;
                color: #fff;
            }

            .pic {
                width: 100%;
                min-height: 164px;

                img {
                    border-radius: 10px 9px 0 0;
                    min-height: 164px;
                    width: 100%;
                    aspect-ratio: 290 / 164;
                    object-fit: cover;
                }
            }

            .info {
                padding: 12px 16px;

                .title {
                    display: flex;
                    justify-content: space-between;
                    font-size: 15px;
                    color: #333;
                    font-weight: 600;
                    line-height: 21px;


                    .price {
                        color: #FF0000;
                        margin-left: 5px;
                    }
                }

                .text {
                    color: rgba(23, 26, 29, 0.4);
                    margin-top: 10px;
                }

                .status {
                    display: flex;
                    align-items: center;
                    margin: 5px 0;
                    color: #333;
                }

                .provide {
                    background-color: #f7faff;
                    padding: 8px 6px;
                    border-radius: 8px;

                    .logo {
                        display: flex;
                        align-items: center;

                        img {
                            width: 16px;
                            height: 16px;
                        }

                        span {
                            line-height: 16px;
                            margin-left: 8px;
                            color: #414141;
                        }
                    }
                }
            }
        }

    }

    .course-box:nth-child(4n) {
        margin-right: 0;
    }

    .pagination {
        margin-top: 12px;
        width: 100%;
        text-align: center;

        ::v-deep .ant-pagination-item {
            margin: 0 4px !important;
        }

        ::v-deep .ant-pagination-options-quick-jumper {
            margin-left: 12px !important;
        }
    }
}

.ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.empty {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}

.cate {
    background-color: #f7f7f7;
    padding: 5px;
    border-radius: 6px;
    margin-bottom: 8px;

    .cate-first {
        margin-bottom: 0;
    }

    .cate-box {
        display: flex;
        flex-wrap: wrap;
        margin-top: 6px;
        background-color: #fff;
        padding: 8px 24px;
        border-radius: 5px;

        .cate-text {
            color: #747778;
            margin-right: 24px;
        }

        .cate-text:hover {
            opacity: 0.8;
        }

        .active {
            color: #3198FF;
        }
    }
}

.download {
    width: 40px;
    padding-top: 4px;
    display: inline-block;
    margin-left: 10px;
    text-decoration: underline;
    position: relative;
}
</style>